/*
 * Copyright (c) 2023. Collabro Limited
 */
import React from "react";
import { Switch, Typography } from "@mui/material";
import { DisplayController } from "RosterData";

export interface Settings {
  displayName: string;
  name:
    | "showPersonnelId"
    | "showGender"
    | "showEmployer"
    | "showDiscipline"
    | "showJobTitle"
    | "showCoreCrew"
    | "showTeam"
    | "showDeptCode"
    | "showTraffic"
    | "showTotals";
  settings: DisplayController;
  setter: any;
}

const SettingsToggle = (props: Settings) => {
  const handleSwitchChange = (e: any) => {
    props.setter({ ...props.settings, [props.name]: e.target.checked });
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        width: 230,
      }}
    >
      <Typography mr={1}>{props.displayName}</Typography>
      <Switch
        checked={props.settings[props.name]}
        onChange={handleSwitchChange}
      />
    </div>
  );
};

export default SettingsToggle;
